import React from "react";

export function useMediaQuery(queryInput, options = {}) {
  const query = queryInput.replace("@media ", "");
  const { defaultMatches = false, noSsr = false } = options;

  const [matches, setMatches] = React.useState(() => {
    if (noSsr) {
      return window.matchMedia(query).matches;
    }
    // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.
    return defaultMatches;
  });

  React.useEffect(() => {
    const queryList = window.matchMedia(query);
    setMatches(queryList.matches);

    function handleMatchesChange(event) {
      setMatches(event.matches);
    }

    queryList.addListener(handleMatchesChange);
    return () => {
      queryList.removeListener(handleMatchesChange);
    };
  }, [query]);
  return matches;
}

export default useMediaQuery;
